export const GenderTypes = Object.freeze({
  MALE: 'male',
  FEMALE: 'female'
});
